export default {
  // Navigation
  'nav.home': 'Home',
  'nav.about': 'About Us',
  'nav.companies': 'Megatrends',
  'nav.gallery': 'Gallery',
  'nav.news': 'News',
  'nav.careers': 'Careers',
  'nav.locations': 'Locations',
  'nav.faq': 'FAQ',
  'nav.contact': 'Contact',

  // Hero Section
  'hero.subtitle': 'Multinational Business Holding',
  'hero.title': 'IVG CORP',
  'hero.description': 'We are a diversified business ecosystem that integrates six leading companies in their respective sectors. Our strategic vision drives sustainable growth and continuous innovation in each of our operations.',
  'hero.cta': 'Discover Companies',

  // Companies Section
  'companies.subtitle': 'Our Ecosystem',
  'companies.title': 'MEGATRENDS',
  'companies.megatendencias': 'Megatrends',
  'companies.cta': 'Learn More',
  'companies.inkavida_global.name': 'Inkavida Global',
  'companies.inkavida_global.description': 'Leading company in natural products and wellness, committed to the comprehensive health of our customers.',
  'companies.club_inkavida.name': 'Club Inkavida',
  'companies.club_inkavida.description': 'Exclusive membership community offering unique benefits and loyalty programs for our partners.',
  'companies.inmobiliaria_inkavida.name': 'Inmobiliaria Inkavida',
  'companies.inmobiliaria_inkavida.description': 'Development of innovative real estate projects, strategic investments and sustainable urban transformation.',
  'companies.hipermercados_inkavida.name': 'Hipermercados Inkavida',
  'companies.hipermercados_inkavida.description': 'Expanding retail chain focused on high-quality wholesale and retail commerce.',
  'companies.inversiones_inkavida.name': 'Inversiones Inkavida',
  'companies.inversiones_inkavida.description': 'Division specialized in financial expansion, strategic capitalization and high-impact project development.',
  'companies.super_inka.name': 'Super Inka',
  'companies.super_inka.description': 'Manufacturing plant and product development with cutting-edge technology and international quality standards.',

  // Philosophy Section
  'philosophy.subtitle': 'Our Ecosystem',
  'philosophy.title': 'Our Philosophy',
  'philosophy.god.title': 'GOD',
  'philosophy.god.description': 'We recognize God as the foundation of our values and principles, guiding our decisions with integrity, honesty and respect for all.',
  'philosophy.family.title': 'FAMILY',
  'philosophy.family.description': 'We value family as the core of our society, promoting the well-being, unity and personal growth of each member of our community.',
  'philosophy.business.title': 'BUSINESS',
  'philosophy.business.description': 'We develop sustainable and prosperous businesses that generate value for all our stakeholders, contributing to economic and social development.',

  // Business Model Section
  'business.subtitle': 'Corporate Strategy',
  'business.title': 'Strategic Business Integration',
  'business.description': 'Intelligent diversification and operational synergy to maximize the value of our business ecosystem.',
  'business.diversification.title': 'Strategic Diversification',
  'business.diversification.description': 'Consolidated presence in multiple economic sectors that guarantee stability and sustained growth in the Latin American market.',
  'business.synergy.title': 'Corporate Synergy',
  'business.synergy.description': 'Operational integration that enhances the capabilities of each company, optimizing resources and maximizing group results.',
  'business.expansion.title': 'International Expansion',
  'business.expansion.description': 'Global vision with growth projection in strategic Latin American markets and planned expansion to new territories.',
  'business.innovation.title': 'Continuous Innovation',
  'business.innovation.description': 'Constant investment in technology, development and research to maintain competitive leadership in each sector.',
  'business.vision.title': 'Comprehensive Vision',
  'business.vision.description': 'Complete coverage of the value cycle in each industry where we participate',
  'business.commitment.title': 'Commitment',
  'business.commitment.description': 'Total dedication to operational excellence and customer satisfaction',
  'business.growth.title': 'Growth',
  'business.growth.description': 'Unlimited potential for expansion and development in new markets and sectors',

  // Impact Section
  'impact.title': 'Impact and Responsibility',
  'impact.description': 'We generate sustainable value for our stakeholders and the communities where we operate',
  'impact.companies.title': 'Consolidated Companies',
  'impact.companies.description': 'Strategic diversification in key sectors of the economy',
  'impact.experience.title': 'Years of Experience',
  'impact.experience.description': 'Experience and solidity in the Latin American market',
  'impact.jobs.title': 'Jobs Generated',
  'impact.jobs.description': 'Contribution to the economic and social development of the region',

  // CTA Section
  'cta.title': 'Join the IVG Ecosystem',
  'cta.description': 'Discover collaboration and growth opportunities within our business holding',
  'cta.contact': 'Contact Now',
  'cta.opportunities': 'View Opportunities',

  // Events Section
  'events.title': 'Our Events',

  // Footer
  'footer.description': 'Multinational business holding committed to excellence and innovation.',
  'footer.companies': 'MEGATRENDS',
  'footer.corporate': 'Corporate',
  'footer.about': 'About Us',
  'footer.megatrends': 'Megatrends',
  'footer.opportunity': 'Opportunity',
  'footer.resources': 'Resources',
  'footer.faq': 'FAQ',
  'footer.support': 'Support',
  'footer.contact': 'Contact',
  'footer.address': 'Address',
  'footer.phone': 'Phone',
  'footer.whatsapp': 'WhatsApp',
  'footer.email': 'Email',
  'footer.complaints_book': 'Complaints Book',
  'footer.rights': '© 2026 IVG CORP. All rights reserved.',
};